import { atom } from 'recoil';
import { ValueLabelResponse } from 'types';

export const filterConsultationTypeState = atom<ValueLabelResponse[]>({
  key: 'filterConsultationType',
  default: [],
});

export const filterStatusState = atom<ValueLabelResponse[]>({
  key: 'filterStatus',
  default: [],
});

export const filterAssigneeState = atom<ValueLabelResponse[]>({
  key: 'filterAssignee',
  default: [],
});

export const filterAuthorityState = atom<ValueLabelResponse[]>({
  key: 'filterAuthority',
  default: [],
});

export const filterCategoryState = atom<ValueLabelResponse[]>({
  key: 'filterCategory',
  default: [],
});

export const filterDateFromState = atom<Date | undefined>({
  key: 'filterDateFrom',
  default: undefined,
});

export const filterDateToState = atom<Date | undefined>({
  key: 'filterDateTo',
  default: undefined,
});

export const filterTeamState = atom<ValueLabelResponse[]>({
  key: 'filterTeam',
  default: [],
});

export const filterAtoms = [
  filterConsultationTypeState,
  filterStatusState,
  filterAssigneeState,
  filterAuthorityState,
  filterCategoryState,
  filterDateFromState,
  filterDateToState,
  filterTeamState,
];
